import React from 'react';
import Navbar from './components/Navbar';
import Header from './components/Header';
import About from './components/About';
import Videos from './components/Videos';
import Recordings from './components/Recordings';
import Teaching from './components/Teaching';
import Contact from './components/Contact';

function App() {
  return (
    <div
      className="App"
      style={{
        background: '#000000',
        minHeight: '100vh',
      }}
    >
      {/* Navbar */}
      <Navbar />

      {/* Main Content Wrapper */}
      <div
        className="mx-auto px-4 sm:px-5 py-0"
        style={{
          maxWidth: '110em',
          paddingTop: 0,
        }}
      >
        <Header />
        <About />
        <Videos />
        <Recordings />
        <Teaching />
        <Contact />
      </div>
    </div>
  );
}

export default App;
